(ns io.daskul.webapp.widgets.form.weekdays
  "Pure helpers for the weekday recurrence picker (#484).

   Kept free of any UI import so it compiles under the :node-test harness —
   the React component lives in weekday_picker.cljs and requires this.

   Selection is a vector of lowercase day tokens (\"mon\" … \"sun\"), matching
   the Class aggregate's [:vector [:enum …]] schema. Everything here returns a
   selection in canonical week order, so the stored value never depends on the
   order the user happened to tap.")

(def ordered-days
  "Canonical week order. The stored vector is always sorted by this."
  ["mon" "tue" "wed" "thu" "fri" "sat" "sun"])

(def ^:private day-index
  (into {} (map-indexed (fn [i d] [d i])) ordered-days))

(def day-labels
  "Three-letter labels, used both on the toggles and in `summary`. Deliberately
   not single initials — M/T/W/T/F/S/S makes Tue/Thu and Sat/Sun ambiguous."
  {"mon" "Mon" "tue" "Tue" "wed" "Wed" "thu" "Thu"
   "fri" "Fri" "sat" "Sat" "sun" "Sun"})

(def ^:private weekdays #{"mon" "tue" "wed" "thu" "fri"})
(def ^:private weekend #{"sat" "sun"})

(defn normalize
  "Dedupe, drop unrecognized tokens, and sort into canonical week order."
  [days]
  (->> days
       (filter day-index)
       distinct
       (sort-by day-index)
       vec))

(defn selected?
  [days day]
  (boolean (some #{day} days)))

(defn toggle
  "Add `day` if absent, remove it if present. Always returns a normalized
   selection, so tapping Fri then Mon still stores [\"mon\" \"fri\"]."
  [days day]
  (if (selected? days day)
    (vec (remove #{day} (normalize days)))
    (normalize (conj (vec days) day))))

(defn summary
  "Short human description of the selection, for the field's helper text."
  [days]
  (let [ds (normalize days)
        s (set ds)]
    (cond
      (empty? ds) "No days selected"
      (= 7 (count ds)) "Every day"
      (= s weekdays) "Weekdays (Mon–Fri)"
      (= s weekend) "Weekends"
      :else (->> ds (map day-labels) (interpose ", ") (apply str)))))
